import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const userData = localStorage.getItem("user");
  if (!userData) {
    return <Navigate to="/sign-in" replace />;
  }
  try {
    const parsed = JSON.parse(userData);
    if (!parsed.access_token) {
      return <Navigate to="/sign-in" replace />;
    }
  } catch {
    return <Navigate to="/sign-in" replace />;
  }
  return children;
}
